import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './SurpriseWizard.css';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { deepEqual } from 'fast-equals';
import { useLocation } from 'react-router-dom';
import { canUseDOM, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get } from '../../utils/getPropertyByPath';
import { SurpriseWizardSelect } from './components/SurpriseWizardSelect';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SurpriseWizardPOI } from './components/SurpriseWizardPOI';
import { qsToObject } from '../../utils/querystring';
import { splitter } from '../Listing';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { isNotNil } from '../../utils/IsNil';
import { checkJssError } from '../../utils/checkJssError';
import { replacerPlusAndAmpersandForValidQueryString } from '../../utils/replacerPlusAndAmpersandForValidQueryString';
var SurpriseWizardComponent = function SurpriseWizardComponent(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var location = useLocation();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    tagSelectWithDescription = _useState4[0],
    setTagSelectWithDescription = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    removedOldQueryString = _useState6[0],
    setRemovedOldQueryString = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSomeSelectOpen = _useState8[0],
    setIsSomeSelectOpen = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    queryString = _useState10[0],
    setSetQueryString = _useState10[1];
  var subtitle = get(fields, "data.datasource.subtitle.jss.value");
  var mainText = get(fields, "data.datasource.mainText.jss.value");
  var travelerTypes = get(fields, "data.datasource.travelerTypes.targetItem");
  var travelerTypesName = get(fields, "data.datasource.travelerTypes.targetItem.title.jss.value");
  var activityInterests = get(fields, "data.datasource.activityInterests.targetItem");
  var activityInterestsName = get(fields, "data.datasource.activityInterests.targetItem.title.jss.value");
  var tripTypes = get(fields, "data.datasource.tripTypes.targetItem");
  var tripTypesName = get(fields, "data.datasource.tripTypes.targetItem.title.jss.value");
  var surpriseCTAHref = get(fields, "data.datasource.surpriseCTA.jss.value.href");
  var preselectedPOIS = get(fields, "data.datasource.preselectedPOIS.values");
  var algoliaIndexes = get(params, 'SearchIndex');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var moduleDictionary = get(fields, 'data.moduleDictionary');
  var shuffleText = getDictionaryItem(moduleDictionary, 'Shuffle') || 'Shuffle';
  var surpriseCTAText = getDictionaryItem(moduleDictionary, 'SurpriseMe') || 'Surprise me';
  var selectNames = [travelerTypesName, activityInterestsName, tripTypesName];
  var isPreselectedValueExists = [travelerTypes, activityInterests, tripTypes].some(function (element) {
    return element && element.preselectedTags.values.length;
  });
  var typesMap = function typesMap() {
    var types = ["travelerTypes", "activityInterests", "tripTypes"];
    var baseObject = fields.data.datasource;
    return types.reduce(function (acc, type) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty2({}, baseObject[type].targetItem.title.jss.value, baseObject[type].targetItem.fieldNameItem.item.fieldName.value));
    }, {});
  };
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var regexWithParentheses = /\{.*?\}/g;
  var getDescriptionFromMainText = useMemo(function () {
    return mainText.replace(regexWithParentheses, '!,').split("!,").reduce(function (acc, value) {
      if (value.length === 0) {
        return acc;
      }
      acc.push(value.trim());
      return acc;
    }, []);
  }, []);
  var getSelectNamesFromMainText = useMemo(function () {
    return mainText.match(regexWithParentheses).map(function (match) {
      return match.replace(/^\{|\}$/g, '');
    });
  }, []);
  var selectMap = {
    trip_type: tripTypes,
    activity_interests: activityInterests,
    traveller_type: travelerTypes,
    traveler_type: travelerTypes
  };
  var matchSelectTypes = useCallback(function (selectNames) {
    return selectNames.map(function (selectName) {
      return selectMap[selectName];
    });
  }, []);
  useEffect(function () {
    var selectNames = mainText ? getSelectNamesFromMainText : [];
    var description = mainText ? getDescriptionFromMainText : [];
    var selectTypes = selectNames.length ? matchSelectTypes(selectNames) : [travelerTypes, activityInterests, tripTypes];
    // lastTextElement is needed if we have text after last {select} in "mainText"
    var selectTypesWithLastText = description.length > 3 ? [].concat(_toConsumableArray(selectTypes), ["lastTextElement"]) : selectTypes;
    var selectsDataWithDescription = selectTypesWithLastText.map(function (selectData, index) {
      var eventsAnalyticsData = null;
      if (index === 0) {
        eventsAnalyticsData = eventsAnalytics["TrevelingAsClickAnalytics"];
      }
      if (index === 1) {
        eventsAnalyticsData = eventsAnalytics["InterestedInClickAnalytics"];
      }
      if (index === 2) {
        eventsAnalyticsData = eventsAnalytics["LookingForClickAnalytics"];
      }
      if (index === 3) {
        return {
          eventsAnalyticsData: null,
          selectData: null,
          description: description[index]
        };
      }
      return {
        eventsAnalyticsData: eventsAnalyticsData,
        selectData: selectData,
        description: description[index]
      };
    });
    setTagSelectWithDescription(selectsDataWithDescription);
  }, []);
  var createQueryParams = function createQueryParams() {
    var queryParams = canUseDOM ? qsToObject(location.search) : {};
    if (Object.keys(queryParams).length !== 0) {
      for (var key in queryParams) {
        var newKeys = key.split('+').join(' ');
        queryParams[newKeys] = queryParams[key].split(splitter).join(', ');
        queryParams[newKeys] = replaceUrlPluses(queryParams[newKeys]) || queryParams[newKeys];
        if (key !== newKeys) {
          delete queryParams[key];
        }
      }
    }
    return queryParams;
  };
  var queryParams = createQueryParams();
  useEffect(function () {
    if (!deepEqual(queryString, queryParams)) {
      setSetQueryString(queryParams);
    }
  }, [queryParams]);
  var isSurpriseButtonEnabled = useCallback(function () {
    return isNotNil(queryString) ? Object.keys(queryString).every(function (key) {
      return queryParams[key].length;
    }) : false;
  }, [queryString]);
  var queryStringForSurpriseCta = function queryStringForSurpriseCta() {
    var str = "?";
    var fieldTypeToFieldValueMap = {};
    if (Object.keys(queryParams).length !== 0) {
      for (var _i = 0, _Object$entries = Object.entries(typesMap()); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (queryParams[key]) {
          if (fieldTypeToFieldValueMap[value]) {
            fieldTypeToFieldValueMap[value] = fieldTypeToFieldValueMap[value].concat(splitter, replacerPlusAndAmpersandForValidQueryString(queryParams[key]));
          } else {
            fieldTypeToFieldValueMap[value] = replacerPlusAndAmpersandForValidQueryString(queryParams[key]);
          }
        }
      }
      for (var _i2 = 0, _Object$entries2 = Object.entries(fieldTypeToFieldValueMap); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          _key = _Object$entries2$_i[0],
          _value = _Object$entries2$_i[1];
        str += "".concat(_key, "=").concat(_value, "&");
      }
      return str.slice(0, -1);
    }
    return str;
  };
  var blurForTitle = function blurForTitle() {
    return canUseDOM && window.matchMedia("(max-width: 1024px)").matches && isSomeSelectOpen ? "blur" : "";
  };
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields || !fields.data || !fields.data.datasource || !fields.data.datasource.mainText || !fields.data.datasource.travelerTypes || !fields.data.datasource.travelerTypes.targetItem || !fields.data.datasource.activityInterests || !fields.data.datasource.activityInterests.targetItem || !fields.data.datasource.tripTypes || !fields.data.datasource.tripTypes.targetItem) {
    console.info('SurpriseWizard component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SurpriseWizard component is empty: please provide data source]");
    }
    return null;
  }
  var analyticsHandle = function analyticsHandle() {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SurpriseMeButtonClickAnalytics'], params), surpriseCTAText);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "surpriseWizardWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tagDropdownsWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tagDropdownsTitle ".concat(blurForTitle())
  }, subtitle.toUpperCase()), /*#__PURE__*/React.createElement("div", {
    className: "tagDropdowns ".concat(isSomeSelectOpen ? "blur" : "")
  }, tagSelectWithDescription.map(function (_ref2, index) {
    var selectData = _ref2.selectData,
      description = _ref2.description,
      eventsAnalyticsData = _ref2.eventsAnalyticsData;
    return /*#__PURE__*/React.createElement("div", {
      className: "tagDropdown",
      key: index
    }, /*#__PURE__*/React.createElement("span", {
      className: "tagDropdownDescription"
    }, description), selectData && /*#__PURE__*/React.createElement(SurpriseWizardSelect, {
      selectData: selectData,
      setIsSomeSelectOpen: setIsSomeSelectOpen,
      setRemovedOldQueryString: setRemovedOldQueryString,
      eventsAnalyticsData: eventsAnalyticsData,
      params: params
    }));
  })), /*#__PURE__*/React.createElement("a", {
    "aria-label": "Surprise CTA",
    "aria-labelledby": "Surprise CTA",
    href: "".concat(surpriseCTAHref).concat(queryStringForSurpriseCta()),
    className: "".concat(isSomeSelectOpen ? "blur" : ""),
    onClick: analyticsHandle
  }, /*#__PURE__*/React.createElement("button", {
    disabled: !isSurpriseButtonEnabled(),
    className: "surpriseCTAButton ".concat(isSurpriseButtonEnabled() ? "enabled" : "disabled")
  }, surpriseCTAText))), /*#__PURE__*/React.createElement("div", {
    className: "POIWrapper"
  }, /*#__PURE__*/React.createElement(SurpriseWizardPOI, {
    preselectedPOIS: preselectedPOIS,
    algoliaIndexes: algoliaIndexes,
    shuffleText: shuffleText,
    selectNames: selectNames,
    queryParams: queryString,
    removedOldQueryString: removedOldQueryString,
    isPreselectedValueExists: isPreselectedValueExists,
    eventsAnalytics: eventsAnalytics,
    params: params
  }))));
};
var SurpriseWizard = function SurpriseWizard(props) {
  return checkJssError(props, SurpriseWizardComponent);
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1btmun6";
var rtlStyles = "r11l924t";
var ltrStyles = "l1i3mbnk";
export default SurpriseWizard;